import { useState } from "react";
import useTrackWebContext from "../../../hooks/useTrackWebContext";
import IconModalOk from "./IconModalOk";
import IconModalError from "./IconModalError";
import { getComprobante } from "../../../utilities/services";
import InputSpinner from "../../common/InputSpinner";
import { ReactComponent as DownloadIcon } from "../../../media/download.svg";

const SaleModal = ({
  token,
  modal,
  userData,
  amount,
  processedAmount,
  processedDiscount,
  cleanUpActivity,
}) => {
  const { handleModalClick } = useTrackWebContext();

  const { first_name, last_name, identification_number } = userData;

  const [isDownloading, setIsDownloading] = useState(false);

  const handleClick = () => {
    handleModalClick();
    if (!modal.error) {
      cleanUpActivity();
    }
  };

  const handleDownloadPDF = async () => {
    if (!modal.transaction_id) {
      alert("No se pudo generar el comprobante. Inténtelo más tarde.");
      return;
    }

    setIsDownloading(true);
    try {
      const response = await getComprobante(modal.transaction_id, token);

      if (!response || !response.data) {
        alert(
          "Hubo un problema al obtener el comprobante. Por favor, inténtelo nuevamente."
        );
        throw new Error("La respuesta del servidor es inválida.");
      }

      const blob = new Blob([response.data], { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `comprobante_${modal.transaction_id}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      alert("El comprobante se ha descargado con éxito.");
    } catch (error) {
      console.error("Error al descargar el PDF:", error);
      alert("Error al descargar el comprobante. Inténtalo nuevamente.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center fixed top-0 left-0 right-0 z-[200] bg-gray-900/50 backdrop-blur-sm transition-opacity">
      <div className="relative w-4/5 h-4/5 max-w-4xl flex flex-col bg-white shadow-md my-0 mx-auto rounded-lg font-body text-gray-900 text-center">
        <div className="flex justify-end p-4">
          <button onClick={handleClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Icon_ionic-md-close"
                d="M21.523,8.923l-1.4-1.4-5.6,5.6-5.6-5.6-1.4,1.4,5.6,5.6-5.6,5.6,1.4,1.4,5.6-5.6,5.6,5.6,1.4-1.4-5.6-5.6Z"
                transform="translate(-7.523 -7.523)"
              />
            </svg>
          </button>
        </div>
        {modal.error ? (
          <div className="h-screen my-4 md:my-4 mx-4 md:mx-8 flex flex-col items-center justify-evenly px-2 py-4 md:p-4 border-2 rounded-xl border-red-600">
            <div className="flex items-center justify-center pb-4 mb-4 border-b-gray-200 border-b">
              <IconModalError />
              <h1 className="font-bold text-xl">{modal.msg}</h1>
            </div>
            <p className="text-lg text-normal pb-2">
              ¿Necesitás contactarnos? Podés hacerlo de lunes a viernes, entre
              las 8 y las 20.
            </p>
            <p className="text-lg text-normal pb-2">
              <b>Correo eletrónico:</b> atencion@lavozdelinterior.com.ar
            </p>
            <p className="text-lg text-normal pb-2">
              <b>Whatsapp:</b> +54 9 351 884 2000
            </p>
            <p className="text-lg text-normal">
              <b>Llamada telefónica:</b> 0800 555 2869
            </p>
          </div>
        ) : (
          <div className="h-screen my-4 md:my-4 mx-4 md:mx-8 flex flex-col items-center justify-evenly px-2 py-4 md:p-4 border-2 border-[#2DC361] rounded-xl">
            <div className="w-full flex items-center justify-center pb-4 mb-4 border-b-gray-200 border-b">
              <IconModalOk />
              <h1 className="font-bold text-xl">Promoción aplicada</h1>
            </div>
            <div name="user-data" className="font-normal pb-4">
              <h1 className="text-xl">
                {first_name} {last_name}
              </h1>
              <p className="text-lg pb-4">
                <b>DNI:</b> {identification_number}
              </p>
            </div>
            <div>
              <p className="text-normal font-normal pb-1">
                Importe sin descuento: ${amount}
              </p>
              <p className="text-normal font-normal pb-1">
                Descuento a aplicar: ${processedDiscount}
              </p>
              <p className="text-2xl font-bold pt-4">
                Total a pagar: ${processedAmount}
              </p>
              {isDownloading ? (
                <div className="flex justify-center">
                <InputSpinner text="Descargando..." />
                </div>
              ) : (
                <button
                  onClick={handleDownloadPDF}
                  className="flex items-center justify-center px-4 py-2 my-4 rounded-full transition bg-clvblue text-white"
                >
                  Descargar Comprobante
                  <DownloadIcon className="ml-2 stroke-white" />
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SaleModal;
